/* eslint-disable import/order */
import React, { useEffect, useState } from "react";

import { Typography, Box, Grid, CssBaseline, Toolbar } from "@mui/material";

// import ShipmentsInbound from "./CountsWidgets/ShipInbound";
import StockPosition from "./StockPosition";

import "@fontsource/manrope";

import { Paper, Stack, Divider, DividerProps } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { Section } from "../../models/section";
// import { GenericDataResponse } from "../../models/shipment.count";
import { WidgetFilter } from "../../models/widget.filter";
import DashboardService from "../../services/dashboard.service";
import { useAppState } from "../../context/StateContext";
import { ResourceGroup, ResourceName, ResourceSubGroup } from "../../util/enums";
import { getResourceByNameGroup } from "../../util/getResourceByNameGroup";
import { isMoving, isRetailer, isRetailerPlus, isShipmentTracking } from "../../util/validation";
import { Button as CButton } from "../Form";
import { Color } from "../Form/Button";
import Input from "../Form/Input";
import InputDateRange from "../Form/Input/DateRange";
import AnalyticsGraph from "./AnalyticsGraph";
import ActiveContainers from "./CountsWidgets/ActiveContiners";
import ActiveOrders from "./CountsWidgets/ActiveOrders";
import ActiveQuotes from "./CountsWidgets/ActiveQuotes";
import OrderVolume from "./CountsWidgets/OrderVolume";
import QuotedVolume from "./CountsWidgets/QuotedVolume";
// import ShipmentsAtDc from "./CountsWidgets/ShipAtDc";
// import ShipmentsAtPort from "./CountsWidgets/ShipAtPort";
import VideoSurveys from "./CountsWidgets/VideoSurveys";
// import ContainerDistributionWidget from "./CustomsNTradeWidgets/ContainerDistribution";
// import DespatchesTableWidget from "./CustomsNTradeWidgets/DespatchesTable";
import { useStyles } from "./DashStyleGuides";
// import FilterSectionComponent from "./FilterSectionComponent";
// import DashboardMapWidget from "./GoogleMapsWidget";
import IncomePO from "./IncomePO";
import OrdersByType from "./MovingWidgets/OrdersByType";
import OrderVolumeMetrics from "./MovingWidgets/OrderVolumeMetrics";
import QuotesPerformed from "./MovingWidgets/QuotesPerformed";
import OrdersToShip from "./OrdersToShip";
import OverdueDespatches from "./OverdueDespatches";
import QuotesStatuses from "./MovingWidgets/QuotesStatuses";
import AvgContainerPerWeek from "./CountsWidgets/AvgContainerPerWeek";
import ContainersDelayed from "./CountsWidgets/ContainersDelayed";
import ContainersWaitingAtGate from "./CountsWidgets/ContainerWatingAtGate";
import TotalContainers from "./CountsWidgets/TotalContainers";
import ContainersTracked from "./ShipmentTrackingWidgets/ContainersTracked";
import AverageDelay from "./ShipmentTrackingWidgets/AverageDelay";
import ShipmentTrackedSection from "./ShipmentTrackingWidgets/ShipmentTracked";

import SupplyChainOverview from "./SupplyChainOverview";
import { SupplyChainOverviewProvider } from "./SupplyChainOverview/context";
import FilterMenu from "../Form/FilterMenu";

const today = new Date();

export default function DashMetricsLandingPage() {
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();

  const [isDateRange, setSelectDateRange] = useState(true);
  const [sectionBWidgets, setSectionBWidgets] = useState<Section[]>([]);
  const [sectionDWidgets, setSectionDWidgets] = useState<Section[]>([]);
  const [widgetFilter, setWidgetFilter] = useState<WidgetFilter>({
    dateFrom: `${format(new Date(), "yyyy-MM")}-01`,
    dateTo: format(new Date(), "yyyy-MM-dd"),
    selectToday: false,
    projectName: isRetailerPlus(currentUser?.company) ? "all" : undefined,
  });

  // const [dashCountsData, setDashCountsData] = useState<GenericDataResponse | undefined>(undefined);

  const shipmentTrackingPermission = getResourceByNameGroup(
    ResourceGroup.SHIPMENTS,
    ResourceSubGroup.SHIPMENTS,
    ResourceName.SHIPMENTS,
    currentUser?.resources
  );

  const orderPermission = getResourceByNameGroup(
    ResourceGroup.OPERATIONS,
    ResourceSubGroup.OPERATIONS,
    ResourceName.ORDERS,
    currentUser?.resources
  );

  const quotePermission = getResourceByNameGroup(
    ResourceGroup.SALES,
    ResourceSubGroup.SALES,
    ResourceName.QUOTE,
    currentUser?.resources
  );

  const videoCallPermission = getResourceByNameGroup(
    ResourceGroup.VIDEO_CALL,
    ResourceSubGroup.VIDEO_CALL,
    ResourceName.VIDEO_CALL,
    currentUser?.resources
  );

  // const dispatchPermission = getResourceByNameGroup(
  //   ResourceGroup.OPERATIONS,
  //   ResourceSubGroup.OPERATIONS,
  //   ResourceName.DESPATCHES,
  //   currentUser?.resources
  // );

  // const containerPermission = getResourceByNameGroup(
  //   ResourceGroup.CONTAINERS,
  //   ResourceSubGroup.CONTAINERS,
  //   ResourceName.CONTAINERS,
  //   currentUser?.resources
  // );

  // const shipmentPermission = getResourceByNameGroup(
  //   ResourceGroup.OPERATIONS,
  //   ResourceSubGroup.OPERATIONS,
  //   ResourceName.SHIPMENTS,
  //   currentUser?.resources
  // );

  useEffect(() => {
    if (sectionBWidgets.length === 0) {
      setSectionBWidgets([
        {
          id: 7,
          item: <StockPosition />,
        },
        {
          id: 8,
          item: <IncomePO />,
        },
        {
          id: 9,
          item: <OverdueDespatches />,
        },
        {
          id: 10,
          item: <OrdersToShip />,
        },
      ]);
    }
  }, [sectionBWidgets]);

  useEffect(() => {
    if (sectionDWidgets.length === 0) {
      setSectionDWidgets([
        {
          id: 16,
          item: <AnalyticsGraph />,
        },
      ]);
    }
  }, [sectionDWidgets]);

  useQuery(
    ["shipment.count.containers", widgetFilter],
    () =>
      DashboardService.getShipmentsContainers({
        projectName: widgetFilter.projectName,
        dateTo: widgetFilter.dateTo,
        dateFrom: widgetFilter.dateFrom,
        companyId: currentUser?.companyId,
      }),
    {
      onSuccess: (response) => {
        if (response && response.data) {
          // if (response.data === undefined || response.data === null) return;
          // setDashCountsData({ data: response.data });
        }
      },
      enabled: Boolean(
        isRetailer(currentUser?.company) ||
          isRetailerPlus(currentUser?.company) ||
          isShipmentTracking(currentUser?.company)
      ),
    }
  );

  const renderSectionQuote = () => {
    if (
      quotePermission &&
      quotePermission?.roles_resources &&
      quotePermission?.roles_resources?.view
    ) {
      return (
        <>
          <Box>
            <Grid container direction="row" justifyContent="center" alignItems="center" spacing={4}>
              <QuotesStatuses filterInfo={widgetFilter} />
            </Grid>
          </Box>
          <Box>
            <Grid container direction="row" justifyContent="center" alignItems="center" spacing={4}>
              <QuotesPerformed isTodaySelected={widgetFilter.selectToday} />
            </Grid>
          </Box>
        </>
      );
    }

    return null;
  };

  const renderSectionOrder = () => {
    if (
      orderPermission &&
      orderPermission?.roles_resources &&
      orderPermission?.roles_resources?.view
    ) {
      return (
        <>
          <Box>
            <Grid container direction="row" justifyContent="center" alignItems="center" spacing={4}>
              <OrdersByType isTodaySelected={widgetFilter.selectToday} />
            </Grid>
          </Box>
          <Box>
            <Grid container direction="row" justifyContent="center" alignItems="center" spacing={4}>
              <OrderVolumeMetrics isTodaySelected={widgetFilter.selectToday} />
            </Grid>
          </Box>
        </>
      );
    }

    return null;
  };

  // const renderSectionPurchaseOrder = () => {
  //   if (
  //     shipmentPermission &&
  //     shipmentPermission?.roles_resources &&
  //     shipmentPermission?.roles_resources?.view
  //   ) {
  //     return (
  //       <>
  //         <Box>
  //           <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2}>
  //             <PurchaseOrdersByType isTodaySelected={widgetFilter.selectToday} />
  //           </Grid>
  //         </Box>
  //       </>
  //     );
  //   }

  //   return null;
  // };

  const renderSectionShipmentTracking = () => {
    if (
      shipmentTrackingPermission &&
      shipmentTrackingPermission?.roles_resources &&
      shipmentTrackingPermission.roles_resources.view
    ) {
      return (
        <>
          <Box>
            <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2}>
              <ContainersTracked isTodaySelected={widgetFilter.selectToday} />
              <AverageDelay />
              <ShipmentTrackedSection />
            </Grid>
          </Box>
        </>
      );
    }
  };

  const renderCounts = () => {
    const showQuote = !!quotePermission?.roles_resources?.view;
    const showOrder = !!orderPermission?.roles_resources?.view;
    const showVideoCall = !!videoCallPermission?.roles_resources?.view;

    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={`st-counts-widgets ${classes.widgetWrapper}`}
      >
        <Paper className={classes.widgetCountWrap}>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            divider={<Divider orientation="vertical" flexItem />}
          >
            {showQuote && <ActiveQuotes filterInfo={widgetFilter} />}
            {showQuote && <QuotedVolume filterInfo={widgetFilter} />}
            {showVideoCall && <VideoSurveys filterInfo={widgetFilter} />}
            {showOrder && <ActiveOrders filterInfo={widgetFilter} />}
            {showOrder && <OrderVolume filterInfo={widgetFilter} />}
          </Stack>
        </Paper>
      </Stack>
    );
  };
  const dividerProps: DividerProps = {
    orientation: "vertical",
    flexItem: true,
    sx: { mr: "-1px", display: { xs: "none", md: "block" } },
  };

  const renderShipmentTrackingCounts = () => {
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={`st-counts-widgets ${classes.widgetWrapper}`}
      >
        <Paper className={classes.widgetCountWrap}>
          <Grid container>
            <Grid item xs={6} sm={4} md={"auto"}>
              <ActiveContainers widgetFilter={widgetFilter} />
            </Grid>
            <Divider {...dividerProps} />
            <Grid item xs={6} sm={4} md={"auto"}>
              <AvgContainerPerWeek widgetFilter={widgetFilter} />
            </Grid>
            <Divider {...dividerProps} />

            <Grid item xs={6} sm={4} md={"auto"}>
              <ContainersDelayed widgetFilter={widgetFilter} />
            </Grid>
            <Divider {...dividerProps} />

            <Grid item xs={6} sm={4} md={"auto"}>
              <ContainersWaitingAtGate widgetFilter={widgetFilter} />
            </Grid>
            <Divider {...dividerProps} />
            <Grid item xs={6} sm={4} md={"auto"}>
              <TotalContainers widgetFilter={widgetFilter} />
            </Grid>
          </Grid>
        </Paper>
      </Stack>
    );
  };

  const renderShipmentTrackingContent = () => {
    return (
      <>
        {renderToolbar()}
        {renderShipmentTrackingCounts()}
        {renderSectionShipmentTracking()}
      </>
    );
  };

  const renderMovingContent = () => {
    return (
      <>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {renderToolbar()}
          {renderCounts()}
          {renderSectionQuote()}
          {renderSectionOrder()}
        </Box>
      </>
    );
  };

  // const renderDespatchesWidget = () => {
  //   if (
  //     dispatchPermission &&
  //     dispatchPermission?.roles_resources &&
  //     dispatchPermission?.roles_resources?.view
  //   ) {
  //     return (
  //       <>
  //         <NoBGSectionDivider />
  //         <DespatchesTableWidget filterInfo={widgetFilter} />
  //       </>
  //     );
  //   }

  //   return null;
  // };

  // const renderContainerDistributionWidget = () => {
  //   if (
  //     containerPermission &&
  //     containerPermission?.roles_resources &&
  //     containerPermission?.roles_resources?.view
  //   ) {
  //     return (
  //       <>
  //         <NoBGSectionDivider />
  //         <ContainerDistributionWidget filterInfo={widgetFilter} />
  //       </>
  //     );
  //   }

  //   return null;
  // };

  // const renderCountContainers = () => {
  //   if (
  //     containerPermission &&
  //     containerPermission?.roles_resources &&
  //     containerPermission?.roles_resources?.view
  //   ) {
  //     return (
  //       <Paper className={classes.widgetCountWrap}>
  //         <Stack direction="row" spacing={2}>
  //           <ShipmentsInbound dataResponse={dashCountsData} />
  //           <ShipmentsAtPort dataResponse={dashCountsData} />
  //           <ShipmentsAtDc dataResponse={dashCountsData} />
  //         </Stack>
  //       </Paper>
  //     );
  //   }

  //   return null;
  // };

  // const renderCountPurchaseOrders = () => {
  //   if (
  //     shipmentPermission &&
  //     shipmentPermission?.roles_resources &&
  //     shipmentPermission?.roles_resources?.view
  //   ) {
  //     return (
  //       <Stack
  //         direction="row"
  //         justifyContent="space-between"
  //         alignItems="center"
  //         className={`st-counts-widgets ${classes.widgetWrapper}`}
  //       >
  //         <Stack
  //           direction="column"
  //           justifyContent="space-between"
  //           spacing={2}
  //           marginTop="8px"
  //           height="153px"
  //           width="447px"
  //         >
  //           <POPastShipByDateWidget />
  //           <PendingPurchaseOrdersCount />
  //         </Stack>
  //       </Stack>
  //     );
  //   }

  //   return null;
  // };

  // const renderCountContainersAndPurchaseOrders = () => {
  //   if (
  //     (containerPermission &&
  //       containerPermission?.roles_resources &&
  //       containerPermission?.roles_resources?.view) ||
  //     (shipmentPermission &&
  //       shipmentPermission?.roles_resources &&
  //       shipmentPermission?.roles_resources?.view)
  //   ) {
  //     return (
  //       <Stack
  //         direction="row"
  //         justifyContent="space-between"
  //         alignItems="center"
  //         className={`st-counts-widgets ${classes.widgetWrapper}`}
  //       >
  //         {renderCountContainers()}
  //         {renderCountPurchaseOrders()}
  //       </Stack>
  //     );
  //   }

  //   return null;
  // };

  const renderToolbar = () => {
    return (
      <Toolbar className={classes.tlbHeader} disableGutters>
        <FilterMenu isDateRange={isDateRange} setIsDateRange={setSelectDateRange} block={false} />

        {isDateRange ? (
          <InputDateRange
            className={classes.inputDateRange}
            pStartDate={new Date(today.getFullYear(), today.getMonth(), 1)}
            pEndDate={today}
            onChange={(range) => {
              if (range.startDate && range.endDate) {
                setWidgetFilter({
                  dateFrom: format(range.startDate, "yyyy-MM-dd"),
                  dateTo: format(range.endDate, "yyyy-MM-dd"),
                  selectToday: false,
                });
              } else {
                setWidgetFilter({
                  dateFrom: undefined,
                  dateTo: undefined,
                  selectToday: false,
                });
              }
            }}
          />
        ) : (
          <div className={classes.inputDateRange}>
            <Input
              type="date"
              value={widgetFilter.dateFrom}
              onChange={(event) => {
                const date = event.target.value;

                setWidgetFilter({
                  dateFrom: date,
                  dateTo: date,
                  selectToday: false,
                });
              }}
            />
          </div>
        )}

        <CButton
          customColor={Color.SECONDARY}
          className={classes.buttonSpace}
          onClick={(event) => {
            event.preventDefault();
            setWidgetFilter({
              dateFrom: format(new Date(), "yyyy-MM-dd"),
              dateTo: format(new Date(), "yyyy-MM-dd"),
              selectToday: true,
            });
            setSelectDateRange(false);
          }}
        >
          {translate("viewToday")}
        </CButton>

        <Box style={{ flexGrow: 1 }} />
      </Toolbar>
    );
  };

  // const renderMap = () => {
  //   // TODO: Confirm information about the map to be displayed
  //   return null;
  //   if (
  //     shipmentPermission &&
  //     shipmentPermission?.roles_resources &&
  //     shipmentPermission?.roles_resources?.view
  //   ) {
  //     return <DashboardMapWidget />;
  //   }

  //   return null;
  // };

  const renderRetailerOrPlusContent = () => {
    return (
      // <>
      //   <FilterSectionComponent
      //     funcSendFilter={(filterData: WidgetFilter) => {
      //       setWidgetFilter(filterData);
      //     }}
      //   />
      //   {renderCountContainersAndPurchaseOrders()}
      //   {renderMap()}
      //   {renderContainerDistributionWidget()}
      //   {renderSectionPurchaseOrder()}
      //   {renderDespatchesWidget()}
      // </>
      <SupplyChainOverviewProvider>
        <SupplyChainOverview />
      </SupplyChainOverviewProvider>
    );
  };

  const renderContent = () => {
    if (isMoving(currentUser?.company)) return renderMovingContent();
    if (isRetailer(currentUser?.company) || isRetailerPlus(currentUser?.company))
      return renderRetailerOrPlusContent();
    if (isShipmentTracking(currentUser?.company)) return renderShipmentTrackingContent();

    return null;
  };

  return (
    <>
      <Box className={classes.bxTitleHeader}>
        <Typography data-cy="dashboardTitle" className={classes.titleHeader} component="div">
          {translate("hello")} <span>{currentUser && currentUser?.name}!</span>
        </Typography>
      </Box>
      <Box className={classes.rootBox}>
        <CssBaseline />
        {renderContent()}
      </Box>
    </>
  );
}
